<!-- Absence step -->
<div #absenceStep class="absence custom-scrollbar">
    <img *ngIf="appDataTemp?.absenceId == 1" class="absence__image" src="/assets/img/absence1.jpg" />
    <img *ngIf="appDataTemp?.absenceId == 2" class="absence__image" src="/assets/img/absence2.png" />
    <img *ngIf="appDataTemp?.absenceId == 3" class="absence__image" src="/assets/img/absence3.jpg" />

    <!-- Absence reason selection -->
    <div class="absence__select">
        <button
            class="select__button button button_size_small button_theme_main-line"
            [ngClass]="{ select__button_selected: appDataTemp?.absenceId == 2 }"
            (click)="chooseAbsence(2)"
        >
            הפסקה
        </button>

        <button
            class="select__button button button_size_small button_theme_main-line"
            [ngClass]="{ select__button_selected: appDataTemp?.absenceId == 1 }"
            (click)="chooseAbsence(1)"
        >
            חופש
        </button>

        <button
            class="select__button button button_size_small button_theme_main-line"
            [ngClass]="{ select__button_selected: appDataTemp?.absenceId == 3 }"
            (click)="chooseAbsence(3)"
        >
            זמן אישי
        </button>
    </div>

    <div class="absence__card absence__card_time">
        <!-- Event date details -->
        <div class="card__header">
            <div class="card__title">
                <span class="time__icon">
                    <i class="fa-regular fa-calendar-lines"></i>
                </span>

                {{ appDataTemp?.start | date : "dd/MM/yyyy EEE" }}
            </div>

            <span *ngIf="holidayName" class="card__info time__info">
                {{ holidayName }}
            </span>
        </div>

        <div class="card__body">
            <div class="time__content">
                <!-- Time edit button -->
                <button class="time__edit-button button button_size_small button_theme_main-line" [disabled]="isTimeEditing" (click)="editTime()">
                    <i class="fa-regular fa-pen"></i>
                    עריכת שעות
                </button>

                <!-- Inputs that have start and end time -->
                <div class="time__inputs">
                    <div class="time__input-wrapper input-wrapper input-wrapper_with-label">
                        <span class="input-label">התחלה</span>
                        <input
                            class="time__input input"
                            [ngClass]="{ time__input_selected: isTimeEditing && activeTimepicker == 'start' }"
                            [value]="startTime"
                            [disabled]="!isTimeEditing"
                            readonly
                            (click)="chooseStartOrEndTimepicker('start')"
                        />
                    </div>

                    <div class="time__input-wrapper input-wrapper input-wrapper_with-label">
                        <span class="input-label">סיום</span>
                        <input
                            class="time__input input"
                            [ngClass]="{ time__input_selected: isTimeEditing && activeTimepicker == 'end' }"
                            [value]="endTime"
                            [disabled]="!isTimeEditing"
                            readonly
                            (click)="chooseStartOrEndTimepicker('end')"
                        />
                    </div>
                </div>

                <!-- Start timepicker -->
                <mbsc-datepicker
                    *ngIf="activeTimepicker == 'start' && isTimeEditing"
                    [options]="options"
                    [controls]="['time']"
                    display="inline"
                    class="timepicker"
                    [(ngModel)]="startTimepickerValue"
                    [stepMinute]="configDiary?.calScaleInMin"
                    itemHeight="30"
                    [invalid]="startInvalid"
                    (onChange)="onTimeChange('start')"
                >
                </mbsc-datepicker>

                <!-- End timepicker -->
                <mbsc-datepicker
                    *ngIf="activeTimepicker == 'end' && isTimeEditing"
                    [options]="options"
                    [controls]="['time']"
                    display="inline"
                    class="timepicker"
                    [(ngModel)]="endTimepickerValue"
                    [stepMinute]="configDiary?.calScaleInMin"
                    itemHeight="30"
                    [invalid]="endInvalid"
                    (onChange)="onTimeChange('end')"
                >
                </mbsc-datepicker>

                <div *ngIf="isTimeEditing" class="time__buttons">
                    <button class="time__close-button button button_size_small button_theme_gray-line" (click)="closeEditingTime()">ביטול</button>

                    <button class="time__save-button button button_size_small button_theme_main" (click)="saveEditedTime()">שמירה</button>
                </div>
            </div>
        </div>

        <!-- Event duration -->
        <div class="card__footer">
            <i class="time__footer-icon fa-solid fa-clock-nine"></i>
            <span class="time__footer-text">{{ eventDuration }}</span>
        </div>
    </div>

    <!-- Event comment -->
    <div class="absence__card absence__card_description">
        <div class="card__header">
            <div class="card__title">הערות</div>
        </div>

        <div class="card__body">
            <div class="input-wrapper input-wrapper_type_textarea description__input-wrapper">
                <textarea class="input" [(ngModel)]="appDataTemp.remark" placeholder="הוסף הערות..." autocomplete="off"></textarea>
            </div>
        </div>
    </div>

    <!-- Resource dropdown -->
    <div *ngIf="resources" class="absence__card absence__card_resourses">
        <div class="card__header">
            <div class="card__title">פרטים נוספים</div>
        </div>

        <div class="card__body">
            <div class="resources__content">
                <div class="resources__select-wrapper" style="pointer-events: none">
                    <span class="resources__label">מטפל</span>

                    <div class="resources__button-wrapper">
                        <mbsc-button class="resources__button" [options]="options" (click)="toggleResourceList()" disabled>
                            <img class="button__icon" src="{{ getResourceImage(selectedResource?.imagePath) }}" />
                            <span class="button__name">{{ selectedResource?.name }}</span>
                        </mbsc-button>
                    </div>

                    <div class="resources__list" [ngClass]="{ resources__list_opened: isResourceListOpened }">
                        <div class="resources__option" *ngFor="let resource of resources" (click)="chooseResource(resource)">
                            <img class="option__icon" src="{{ getResourceImage(resource.imagePath) }}" />
                            <span class="option__name">{{ resource.name }}</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="isResourceListOpened" class="resources__background" (click)="toggleResourceList()"></div>
            </div>

            <div *ngIf="isEditingEvent" class="resources__creation">
                אירוע זה נוצר בתאריך {{ appDataTemp?.creationDate | date : "dd/MM/yyyy 'בשעה' HH:mm " }}
            </div>
        </div>
    </div>
</div>
